/**
 * MAP (in-file navigation graph — any LLM reads this without external tooling;
 * keep in sync with the code):
 *   role:      component — «UI nuova» fork of the modulo (document + consents)
 *              step of the multi-step booking form (step M18 bk-forms)
 *   extends:   FormStepModuloComponent (form-step-modulo.js)
 *   template:  form-step-modulo-nuova.hbs
 *   args:      @step, @applicationController, @onNext, @isLastStep (as the parent)
 *   uses:      everything inherited (terms, pdfUrl, toggleTerm, acceptTask, accept)
 *   siblings:  form-nuova.hbs (its only caller), form-step-modulo.js
 *   tests:     tests/acceptance/ui-nuova-bk-forms-test.js
 *
 * Template-only fork: no logic of its own. Rendered by FormNuova instead of
 * FormStepModulo so the accept button can explain an unticked required consent
 * (nv-disabled-reason) instead of the classic silent disabled.
 */
import FormStepModuloComponent from './form-step-modulo';

export default class FormStepModuloNuovaComponent extends FormStepModuloComponent {}
